import stili from './stili';
import { normalizzaOrario, durataDaOrari, parseEuro, formattaEuro, suggerisciImporto } from '../../utils/importi';
import { formattaDurata } from '../../utils/durata';

// Chi ha svolto, Dalle/Alle (24 ore), durata calcolata, diritti, bollo e importo con l'importo suggerito.
// Usato nella nuova riga e nella modifica. `valori` e `onCambia(campo, valore)`.
export default function CampiPratica({ valori, onCambia, operatori, tariffe, minutiRegistrati = null, esecutoreAttuale = null }) {
  const durata = durataDaOrari(valori.dalle, valori.alle);
  const sugg = suggerisciImporto({ ...valori, operatori, tariffe });
  const importoVuoto = parseEuro(valori.importo).valore === null && !parseEuro(valori.importo).errore;

  const orario = (campo, etichetta) => (
    <div style={stili.campo}>
      <label style={stili.label}>{etichetta}</label>
      <input
        value={valori[campo]} inputMode="numeric" maxLength={5} placeholder="HH:MM" aria-label={etichetta}
        onChange={e => onCambia(campo, e.target.value.replace(/[^\d:.,]/g, ''))}
        onBlur={e => { const n = normalizzaOrario(e.target.value); if (n.valore) onCambia(campo, n.valore); }}
        style={{ ...stili.input, ...(durata.errore ? { borderColor: '#c00' } : {}) }}
      />
    </div>
  );
  const euro = (campo, etichetta) => {
    const p = parseEuro(valori[campo], etichetta);
    return (
      <div style={stili.campo}>
        <label style={stili.label}>{etichetta} (€)</label>
        <input
          value={valori[campo]} inputMode="decimal" placeholder="0,00" aria-label={etichetta}
          onChange={e => onCambia(campo, e.target.value)}
          onBlur={e => { const n = parseEuro(e.target.value); if (n.valore !== null && !n.errore) onCambia(campo, formattaEuro(n.valore)); }}
          style={{ ...stili.input, ...(p.errore ? { borderColor: '#c00' } : {}) }}
        />
        {p.errore && <small style={{ color: '#c00' }}>{p.errore}</small>}
      </div>
    );
  };

  return (
    <>
      <div style={stili.row}>
        <div style={{ ...stili.campo, flex: 2 }}>
          <label style={stili.label}>Chi ha svolto</label>
          <select value={valori.eseguito_da} onChange={e => onCambia('eseguito_da', e.target.value)} style={stili.input} aria-label="Chi ha svolto">
            <option value="">—</option>
            {(operatori || []).filter(o => o.attivo !== false || String(o.id) === String(esecutoreAttuale)).map(o => (
              <option key={o.id} value={o.id}>{o.nome} {o.cognome}{o.ruolo_tariffario ? '' : ' (senza ruolo tariffario)'}</option>
            ))}
          </select>
        </div>
        {orario('dalle', 'Dalle')}
        {orario('alle', 'Alle')}
        <div style={stili.campo}>
          <label style={stili.label}>Durata (h:mm)</label>
          <input readOnly tabIndex={-1} aria-label="Durata calcolata" value={durata.minuti ? formattaDurata(durata.minuti) : (minutiRegistrati ? formattaDurata(minutiRegistrati) : '')}
            style={{ ...stili.input, background: '#f4f4f1' }} title="Si calcola da Dalle e Alle" />
        </div>
      </div>
      {durata.errore && <div style={{ ...stili.errore, marginTop: '-0.4rem' }}>{durata.errore}</div>}
      {!durata.minuti && minutiRegistrati ? <small style={{ color: '#777', display: 'block', marginTop: '-0.5rem', marginBottom: '0.6rem' }}>Durata già registrata ({formattaDurata(minutiRegistrati)}): per cambiarla indica Dalle e Alle.</small> : null}
      <div style={stili.row}>
        {euro('diritti_segreteria', 'Diritti di segreteria')}
        {euro('imposta_bollo', 'Imposta di bollo')}
        {euro('importo', 'Importo')}
      </div>
      {sugg.stato === 'ok' && (
        <div style={{ fontSize: '0.84rem', margin: '-0.4rem 0 0.8rem', color: '#555' }}>
          Importo suggerito: <strong>{formattaEuro(sugg.importo)} €</strong> <em>(non salvato: {formattaDurata(sugg.minuti)} × tariffa oraria)</em>
          {importoVuoto && <button type="button" onClick={() => onCambia('importo', formattaEuro(sugg.importo))} style={{ ...stili.btnSmall, marginLeft: '0.5rem' }}>Usa il suggerito</button>}
          {!importoVuoto && <span style={{ marginLeft: '0.5rem', color: '#777' }}>L'importo scritto non viene sovrascritto.</span>}
        </div>
      )}
      {sugg.stato === 'ruolo_mancante' && <div style={{ fontSize: '0.84rem', margin: '-0.4rem 0 0.8rem', color: '#c2410c' }}>Ruolo mancante: chi ha svolto non ha il ruolo tariffario (si imposta in Utenti e permessi), quindi non c'è un importo suggerito.</div>}
      {sugg.stato === 'tariffa_mancante' && <div style={{ fontSize: '0.84rem', margin: '-0.4rem 0 0.8rem', color: '#c2410c' }}>Manca la tariffa oraria di quel ruolo (Parcellazione → Tariffe orarie).</div>}
    </>
  );
}
